import { render, staticRenderFns } from "./ProductExclusions.html?vue&type=template&id=df08cace&scoped=true&external"
import script from "./ProductExclusions.js?vue&type=script&lang=js&external"
export * from "./ProductExclusions.js?vue&type=script&lang=js&external"
import style0 from "./ProductExclusions.scss?vue&type=style&index=0&id=df08cace&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df08cace",
  null
  
)

export default component.exports